var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyPledge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1546_119813)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1546_119813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.570312 18.6892L14.363 28.026L39.6336 11.8442L25.4317 2.40039L0.570312 18.6892Z",
    stroke: "#61A578",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5147 5.11755L28.9332 5.40632C26.1553 7.20312 22.0961 5.40632 22.0961 5.40632C22.0961 5.40632 21.6008 5.16033 21.5039 4.97852",
    stroke: "#61A578",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6925 14.3565C35.317 14.0436 35.016 13.6519 34.8112 13.2095C34.6064 12.7672 34.5028 12.2853 34.508 11.7984C34.5131 11.3116 34.6269 10.8319 34.841 10.394C35.0551 9.95603 35.3643 9.57067 35.7463 9.26562",
    stroke: "#61A578",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7773 25.5984C10.7773 25.5984 13.5983 23.4594 18.3144 25.4915",
    stroke: "#61A578",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46875 16.1641C4.46875 16.1641 7.35435 18.9769 4.46875 21.2977",
    stroke: "#61A578",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21.6726L14.5464 31.0309L40 14.7207",
    stroke: "#61A578",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.6362L14.5464 33.8234L39.9569 17.6309",
    stroke: "#61A578",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 27.6203L14.5464 36.9465L39.9569 20.5508",
    stroke: "#61A578",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1914 12.0898L24.8711 18.4856",
    stroke: "#61A578",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8641 12.2826C19.8641 12.2826 15.3311 12.0473 15.3203 14.2719C15.3096 16.4965 19.0458 15.7264 19.8641 15.3414C21.1561 14.7852 25.0431 13.5232 24.6232 16.8387C24.3109 18.4323 20.5101 18.2612 20.5101 18.2612",
    stroke: "#61A578",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1546_119813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1546_119813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyPledge);
export default __webpack_public_path__ + "static/media/money_pledge.4c5fffb652c065a42ccd254445b06af2.svg";
export { ForwardRef as ReactComponent };